module.exports = __webpack_public_path__ + "static/media/favicon32.de3064d6.png";